import type { FC, ComponentType } from 'react';

interface RenderProps {
    defaultComponent: ComponentType | undefined;
    defaultLayout: ComponentType | undefined;
    defaultLayoutProps?: {};
    path: string;
}

export const Render: FC<RenderProps> = (props: RenderProps) => {
    const { defaultComponent: Component, defaultLayout: Layout, defaultLayoutProps } = props;
  
    // @ts-ignore
    return (<>{Layout && (<Layout {...defaultLayoutProps}>{Component && <Component />}</Layout>)}
        </>
    );
};

export default Render;
